import React from 'react';
import { ShieldCheck, ScrollText, Pill, FlaskConical, FolderClosed, Clock } from 'lucide-react';
import '../patient-health-file-founder-replica.css';

/**
 * DhfFolderShell — reuses the production .phf-* design tokens from
 * `patient-health-file-founder-replica.css` (manila folder, cream paper,
 * navy ink, teal/mint accents, Inter typography, physical depth shadows).
 *
 * Renders the shared folder chrome (side tabs + sheet), highlighting one tab.
 * Children render inside .phf-main. Optional aside for a right drawer.
 */
const ALL_TABS = [
  { key: 'summary',       label: 'Summary',       Icon: ScrollText,   cls: 'phf-tab--summary' },
  { key: 'prescriptions', label: 'Prescriptions', Icon: Pill,         cls: 'phf-tab--prescriptions' },
  { key: 'labs',          label: 'Lab Reports',   Icon: FlaskConical, cls: 'phf-tab--labs' },
  { key: 'documents',     label: 'Documents',     Icon: FolderClosed, cls: 'phf-tab--documents' },
  { key: 'timeline',      label: 'Care Timeline', Icon: Clock,        cls: 'phf-tab--timeline' },
];

export default function DhfFolderShell({ activeTab = 'summary', title, subtitle, badges = [], children, aside }) {
  return (
    <div className="phf-viewport">
      <div className="phf-stage">
        <div className="phf-folder">
          <div className="phf-tabs">
            {ALL_TABS.map(({ key, label, Icon, cls }) => (
              <div key={key}
                className={`phf-tab ${cls} ${activeTab === key ? 'phf-tab--active' : 'phf-tab--soon'}`}>
                <Icon size={15} />
                <span className="phf-tab-label">{label}</span>
              </div>
            ))}
          </div>

          <div className="phf-sheet">
            <div className="phf-board">
              <div className="phf-main">
                <header className="phf-header">
                  <div className="phf-logo">
                    <img src="/docsite-logo.png" alt="DocSite" onError={(e) => { e.target.style.display = 'none'; }} />
                    <span className="phf-logo-text"><b>DocSite</b><span>FOR DOCTORS</span></span>
                  </div>
                  <div className="phf-hdiv" />
                  <div className="phf-shield"><ShieldCheck size={26} /></div>
                  <div className="phf-htitles">
                    <h1>{title}</h1>
                    {subtitle && <p>{subtitle}</p>}
                  </div>
                </header>

                {badges.length > 0 && (
                  <div className="phf-status" style={{ flexWrap: 'wrap' }}>
                    {badges.map((b, i) => (
                      <span key={i} className={`phf-chip ${b.tone === 'blue' ? 'phf-chip--blue' : 'phf-chip--green'}`}>
                        {b.icon}{b.label}
                      </span>
                    ))}
                  </div>
                )}

                {children}
              </div>

              {aside && (
                <aside className="phf-drawer">
                  {aside}
                </aside>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* Reusable Tile helper — same visual language as .phf-tile from CSS */
export function PhfTile({ icon, ico = 'phf-ico-blue', title, right, children, risk = false, style }) {
  return (
    <div className={`phf-tile ${risk ? 'phf-tile--risk' : ''}`} style={style}>
      <div className="phf-tile-head">
        <span className={`phf-tile-ico ${ico}`}>{icon}</span>
        <h3 style={{ flex: 1 }}>{title}</h3>
        {right}
      </div>
      {children}
    </div>
  );
}
